export type ProductPage = {
  src: string
  alt: string
  label: string
}

export const productPages: ProductPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/oJXLpfkCs3Jv7DGtFHXX6v/carrusel-1-portada.png',
    alt: 'Portada del Volumen 3: The Defense Install, con jugadas dibujadas sobre una cancha',
    label: 'Volume 3: The Defense Install',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7BAEi7EF4wGt77w8e4XLZR/carrusel-2-metodo-4-cuartos.png',
    alt: 'Página The Practice Formula: el método de 4 cuartos de 15 minutos cada uno',
    label: 'The Practice Formula',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eJwyaqdzwB1fsGNZAZzwVD/carrusel-3-flag-angle-rule.png',
    alt: 'Página The Flag Angle Rule: diagrama en cancha con los 4 pasos para llegar al punto',
    label: 'The Flag Angle Rule',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nGwYEZjts46ppV7BJTrja7/carrusel-4-zone-boxes.png',
    alt: 'Página Zone Boxes: cinco zonas marcadas con conos y las 4 reglas de cobertura',
    label: 'Zone Boxes',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fsjrLwpuYcmMDtuCUrXkrC/carrusel-5-practice-card.png',
    alt: 'Practice Card D-01: Breakdown Position at Full Speed, con los cuatro cuartos de la práctica',
    label: 'Practice Card D-01',
  },
]
